import { styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';

export const ContentGraphics = styled(Card)(({ width, height }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        height: height,
        width: width,
        padding: '10px',
        borderRadius: '10px',
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    }
});

export const ChartSubtitle = styled('div')(() => {
    return {
        fontSize: '11px',
        color: '#64748b',
        marginTop: '2px',
        marginLeft: '1rem',
    }
});

export const CustomTitleGraphics = styled(Typography)(() => {
    return {
        marginLeft: '1rem',
        fontWeight: 'bold',
        fontSize: '14px',
    }
})

export const SectionDivider = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1.2px',
    color: '#64748b',
    marginTop: '24px',
    marginBottom: '16px',

    '&::after': {
        content: '""',
        flex: 1,
        height: '1px',
        backgroundColor: 'rgba(0,0,0,0.08)',
    }
}))



// ===== KPI CARDS =====
export const KpiGrid = styled('div')(() => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
    gap: '12px',
    marginBottom: '20px'
}));

export const KpiCard = styled(Card)(({ colortype }) => {
    let topColor = '#3b9edd';
    if (colortype === 'red') topColor = '#d32f2f';
    if (colortype === 'green') topColor = '#2e7d32';
    if (colortype === 'yellow') topColor = '#f57f17';
    if (colortype === 'orange') topColor = '#e65100';
    if (colortype === 'purple') topColor = '#7b1fa2';

    return {
        background: '#ffffff',
        border: '1px solid rgba(0,0,0,0.08)',
        borderRadius: '10px',
        padding: '16px',
        position: 'relative',
        overflow: 'hidden',
        transition: 'border-color 0.2s, transform 0.15s',
        cursor: 'default',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
        '&:hover': {
            borderColor: 'rgba(0,0,0,0.15)',
            transform: 'translateY(-1px)'
        },
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '2px',
            backgroundColor: topColor,
            borderRadius: '10px 10px 0 0'
        }
    };
});

export const BtnClear = styled('button')(() => ({
    background: '#f1f5f9',
    border: '1px solid rgba(0,0,0,0.08)',
    color: '#64748b',
    borderRadius: '6px',
    padding: '7px 12px',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.15s',
    whiteSpace: 'nowrap',
    '&:hover': { color: '#1e293b', borderColor: 'rgba(0,0,0,0.15)' }
}));

export const KpiLabel = styled('div')(() => ({
    fontSize: '11px',
    color: '#64748b',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    marginBottom: '8px',
    lineHeight: '1.3'
}));

export const KpiValue = styled('div')(({ colortype }) => {
    let valColor = '#1e293b';
    if (colortype === 'blue') valColor = '#3b9edd';
    if (colortype === 'red') valColor = '#d32f2f';
    if (colortype === 'green') valColor = '#2e7d32';
    if (colortype === 'yellow') valColor = '#f57f17';
    if (colortype === 'orange') valColor = '#e65100';
    if (colortype === 'purple') valColor = '#7b1fa2';

    return {
        fontSize: '32px',
        fontWeight: '700',
        letterSpacing: '-1px',
        lineHeight: '1',
        marginBottom: '6px',
        color: valColor
    };
});

export const KpiSub = styled('div')(() => ({
    fontSize: '11px',
    color: '#64748b'
}));

export const KpiDelta = styled('span')(({ trend }) => {
    let bg = 'rgba(245,127,23,0.12)';
    let color = '#f57f17';

    if (trend === 'up') {
        bg = 'rgba(46,125,50,0.12)';
        color = '#2e7d32';
    } else if (trend === 'down') {
        bg = 'rgba(211,47,47,0.12)';
        color = '#d32f2f';
    }

    return {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        fontSize: '11px',
        fontWeight: '600',
        padding: '1px 6px',
        borderRadius: '4px',
        backgroundColor: bg,
        color: color
    };
});

// ===== TABLA =====
export const TableWrap = styled('div')(() => ({
    overflowX: 'auto',
    padding: '12px 0 0'
}));

export const RimTable = styled('table')(() => ({
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12.5px',
    '& th': {
        padding: '8px 12px',
        textAlign: 'left',
        fontSize: '10px',
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: '0.8px',
        color: '#64748b',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        whiteSpace: 'nowrap'
    },
    '& td': {
        padding: '10px 12px',
        borderBottom: '1px solid rgba(0,0,0,0.08)',
        color: '#64748b',
        verticalAlign: 'middle'
    },
    '& tbody tr:last-child td': {
        borderBottom: 'none'
    },
    '& tbody tr:hover td': {
        background: '#f1f5f9',
        color: '#1e293b'
    }
}));

export const BadgeStatus = styled('span')(({ status }) => {
    let bg = 'rgba(245,127,23,0.12)';
    let color = '#f57f17';

    if (status === 'critica' || status === 'vencido') {
        bg = 'rgba(211,47,47,0.12)'; color = '#d32f2f';
    } else if (status === 'alta') {
        bg = 'rgba(230,81,0,0.12)'; color = '#e65100';
    } else if (status === 'baja' || status === 'cerrado') {
        bg = 'rgba(46,125,50,0.12)'; color = '#2e7d32';
    } else if (status === 'abierto') {
        bg = 'rgba(59,158,221,0.12)'; color = '#3b9edd';
    } else if (status === 'en-proceso') {
        bg = 'rgba(123,31,162,0.12)'; color = '#7b1fa2';
    }

    return {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        backgroundColor: bg,
        color: color
    };
});

export const ProgressBarWrap = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
}));

export const ProgressBar = styled('div')(() => ({
    flex: 1,
    height: '5px',
    background: '#e2e8f0',
    borderRadius: '3px',
    overflow: 'hidden'
}));

export const ProgressFill = styled('div')(({ fillcolor, fillwidth }) => ({
    height: '100%',
    borderRadius: '3px',
    transition: 'width 0.6s ease',
    width: fillwidth,
    backgroundColor: fillcolor
}));

export const ProgressVal = styled('span')(() => ({
    fontSize: '11px',
    color: '#64748b',
    minWidth: '30px',
    textAlign: 'right'
}));
